import { Type, Category, Software } from "app/profile/models/software.model";
import { SearchResult } from 'app/profile/models/generic.model';

export interface SoftwareState {
    softwareTypes: Type[] | null;
    softwareCategories: Category[] | null;
}

export const initialState: SoftwareState = {
    softwareTypes: null,
    softwareCategories: null,
};
